export default __webpack_public_path__ + "static/media/Path2263.78e5cea4.svg";